import React from "react";
import Icon from "../Icon";

const ContractsStepper = ({ stepNames, currentStep }) => {
    const totalSteps = stepNames.length + 1; // includes 'Start'
    const totalSegments = stepNames.length;
    const stepPercentage = (currentStep / totalSegments) * 100;
    const stepsArray = Array.from({ length: totalSteps }, (_, i) => i);

    return (
        <div className="stepper" style={{ width: "100%", padding: "10px 0" }}>
            <div style={{
                width: "100%",
                height: "8px",
                backgroundColor: "#e0e0e0",
                borderRadius: "4px",
                position: "relative"
            }}>
                <div style={{
                    width: `${stepPercentage}%`,
                    height: "100%",
                    backgroundColor: "#6ECEB2",
                    borderRadius: "4px",
                    transition: "width 0.3s ease-in-out"
                }} />
            </div>

            <div className="stepper-steps" style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "5px",
                overflowX: "auto",
                overflowY: "hidden",
                WebkitOverflowScrolling: "touch",
            }}>
                {stepsArray.map(step => (
                    <div key={step} style={{textAlign: "center", flexShrink: 0, minWidth: "60px", maxWidth: "90px"}}>
                        <div style={{
                            width: "20px",
                            height: "20px",
                            borderRadius: "50%",
                            backgroundColor: step <= currentStep ? "#6ECEB2" : "#e0e0e0",
                            display: "inline-flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}>
                            {step !== 0 && step <= currentStep && <Icon type="check" size={12} color="#fff" />}
                        </div>
                        <p style={{marginTop: "5px", fontSize: "12px", wordBreak: "break-word", overflowWrap: "break-word", whiteSpace: "normal"}}>
                            {
                                step === 0
                                    ? "Start"
                                    : stepNames[step - 1] || `Step ${step}`
                            }
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ContractsStepper;